<button mat-button class="menu-button" [matMenuTriggerFor]="userMenu">
    {{email}}<mat-icon>keyboard_arrow_down</mat-icon>
</button>
<mat-menu #userMenu="matMenu">
    <button mat-menu-item (click)="goToProfile()">Profile</button>
    <button mat-menu-item (click)="signout()">Sign Out</button>
</mat-menu>
